import { render, staticRenderFns } from "./recordheader.vue?vue&type=template&id=7334475c&scoped=true&lang=html&"
import script from "./recordheader.vue?vue&type=script&lang=js&"
export * from "./recordheader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7334475c",
  null
  
)

export default component.exports